import { API_ROUTES } from "../config";
import { http } from "../http";

export const listMessageRecipientsService = async (data) => {
    try {
        const responseData = await http().get(API_ROUTES["members"], {
            params: {
                page: data?.currentPage,
                limit: data?.limit,
                search: data?.search,
            },
        });
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const sendMessageService = async (data) => {
    try {
        const responseData = await http().post(`${API_ROUTES.notifications}/broadcast`, data);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};
